// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1wrmz","title":"FrontImage_title__29HyF"};